module.exports = __webpack_public_path__ + "static/media/devchat.3687813b.webp";